import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        lc_checkin_users: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        userMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {


        getUsersRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUsers", null);
            } else {
                dispatch("receivingUsers"); // สถานะ กำลังบันทึก

                axios.get('/mem_lc_checkin_users').then(res => {
                    dispatch("receiveUsers", res.data);
                    console.log(res.data)
                })
                    .catch((e) => {
                        console.log(e)
                        dispatch("receiveUsers", null);
                    })
            }
        },
        loadUserRequest({dispatch}, user_id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveUser", null.find(arr => arr.user_id === user_id));
            } else {
                dispatch("receivingUser");
                axios.get('/mem_lc_checkin_users/' + user_id).then(res => {
                    dispatch("receiveUser", res.data);
                })
            }
        },
        updateUserRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingUser");
            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('user_id', payload.user_id);
            formData.append('user_name', payload.user_name);
            formData.append('user_code', payload.user_code);
            formData.append('user_type', payload.user_type);
            formData.append('prefix_title_th', payload.prefix_title_th);
            formData.append('prefix_title_en', payload.prefix_title_en);
            formData.append('fname_th', payload.fname_th);
            formData.append('lname_th', payload.lname_th);
            formData.append('fname_en', payload.fname_en);
            formData.append('lname_en', payload.lname_en);
            formData.append('user_email', payload.user_email);
            formData.append('user_mobile', payload.user_mobile);
            formData.append('field_title', payload.field_title);
            formData.append('job_title', payload.job_title);
            formData.append('disabled', payload.disabled);

            axios.post('/update_mem_lc_checkin_users', formData).then(res => {
                dispatch("updateUser", res.data);
                console.log(res)
            })
        },
        createUserRequest({dispatch}, payload) {


            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingUser");

            const formData = new FormData();
            formData.append('file', payload.avatarFile);
            formData.append('user_name', payload.user_name);
            formData.append('user_code', payload.user_code);
            formData.append('user_type', payload.user_type);
            formData.append('prefix_title_th', payload.prefix_title_th);
            formData.append('prefix_title_en', payload.prefix_title_en);
            formData.append('fname_th', payload.fname_th);
            formData.append('lname_th', payload.lname_th);
            formData.append('fname_en', payload.fname_en);
            formData.append('lname_en', payload.lname_en);
            formData.append('user_email', payload.user_email);
            formData.append('user_mobile', payload.user_mobile);
            formData.append('field_title', payload.field_title);
            formData.append('job_title', payload.job_title);
            formData.append('disabled', payload.disabled);


            axios.post('/mem_lc_checkin_users', formData).then(res => {
                dispatch("receiveUser", res.data);

            })
        },
        deleteUserRequest({dispatch}, payload) {

            console.log(payload)

            dispatch("afterDeleteUser", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingUser", payload);

            axios.post('/delete_mem_lc_checkin_users', payload).then(res => {
                dispatch("deleteUser", {user_id: payload.user_id, res: res});
            })


        },
        receiveUsers({commit}, payload) {
            commit("RECEIVED_USERS", payload)
        },
        receivingUsers({commit}) {
            commit("RECEIVING_USERS") //call matutions --> state.isReceiving = true;
        },
        receiveUser({commit}, payload) {
            commit("RECEIVED_USER", payload)
        },
        receivingUser({commit}) {
            commit("RECEIVING_USERS") //call matutions --> state.isReceiving = true;
        },
        updateUser({commit}, payload) {
            commit("UPDATED_USER", payload)
        },
        updatingUser({commit}) {
            commit("UPDATING_USER") //  call matutions --> state.isUpdating = true;
        },
        deleteUser({commit}, payload) {
            commit("DELETED_USER", payload)
        },
        deletingUser({commit}, payload) {
            commit("DELETING_USER", payload)
        },
        afterDeleteUser({commit}, payload) {
            commit("AFFTER_DELETED_USER", payload)
        },


    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_USERS(state, payload) {
            state.lc_checkin_users = payload;
            state.isReceiving = false;

        },
        RECEIVING_USERS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_USER(state, payload) {


            if (payload.user_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let userMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),

                });
            } else {

                let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.user_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    lc_checkin_users: [...state.lc_checkin_users, payload],
                    isReceiving: false,
                    errorMessage: false,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_USER(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_USER(state, payload) {

            let index = state.lc_checkin_users.findIndex(p => p.user_id === payload.user_id);
            let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.user_id + ' ถูกแก้ไขแล้ว';

            state = Object.assign(state, {
                lc_checkin_users: state.lc_checkin_users.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
            })
        },
        UPDATING_USER(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_USER(state, payload) {


            if (payload.user_id == undefined || payload.res.data.message == 'Relation') {
                let userMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.user_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),

                });
            } else {
                let indexToDelete = state.lc_checkin_users.findIndex(p => p.user_id === payload.user_id);
                let lc_checkin_users = [...state.lc_checkin_users];
                lc_checkin_users.splice(indexToDelete, 1);
                let userMessage = 'บันทึกสำเร็จ! รายการ ' + payload.user_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    lc_checkin_users: [...lc_checkin_users],
                    isDeleting: false,
                    idToDelete: null,
                    userMessage: (state.userMessage == userMessage ? userMessage + ' ' : userMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_USER(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.user_id;
        },
        AFFTER_DELETED_USER(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
